import React from 'react';

function UnitMenu(menuOpen,
                  menuRef,
                  armySelector,
                  handleClearData,
                  searchQuery,
                  handleSearchInputChange,
                  showCheckedItemsOnly,
                  setShowCheckedItemsOnly,
                  totalPoints, filterMenuItems,
                  handleSubMenuClick, selectedMenu,
                  selectedItems, submenuItemValues,
                  handleAddItemClick, setSubmenuItemValues,
                  handleRemoveItemClick, handleDataItemClick) {
    
    
    return <div className={`menu-container ${menuOpen ? 'menu-open' : ''}`} ref={menuRef}>

        <div
            className={`overflow-auto  fixed  z-50  top-0  left-0  w-[90%]  h-full  p-5  bg-slate-800  text-slate-200  transition ${menuOpen ? 'translate-x-0' : '-translate-x-full'}`}>
            <div className="flex  gap-2">

                {armySelector}

                <button type="button" className="shrink-0  btn  btn-danger" onClick={handleClearData}>Reset</button>
            </div>

            <input
                className="w-full  mt-2  px-2  py-1  rounded-sm  bg-white  text-base  text-slate-800"
                type="text"
                placeholder="Search..."
                value={searchQuery}
                onChange={handleSearchInputChange}
            />

            <div className="flex  items-center  justify-between  mt-2">
                <label className="flex  items-center  gap-1">
                    <input
                        type="checkbox"
                        checked={showCheckedItemsOnly}
                        onChange={() => setShowCheckedItemsOnly(!showCheckedItemsOnly)}
                        onClick={(event) => event.stopPropagation()} // Prevent click event propagation
                    />

                    <span className="text-xs">Show selected units only</span>
                </label>

                <span className="text-xs">Total points: {totalPoints}</span>
            </div>

            <ul className="mt-4  divide-y  divide-slate-600">
                {filterMenuItems().map(({menu, datasheets}) => (
                    <li key={menu} onClick={() => handleSubMenuClick(menu)} className="py-2">
                        <strong>{menu}</strong>
                        {(selectedMenu === menu || searchQuery !== '') && (
                            <ul className="divide-y  divide-slate-600">
                                {datasheets
                                    .filter((subItem) =>
                                        subItem.NAME.toLowerCase().includes(searchQuery.toLowerCase())
                                    )
                                    .map((subItem, subIndex) => {
                                        const itemCount = selectedItems[subItem.NAME] || 0;
                                        const {
                                            nextValue = '',
                                            nextPoints = ''
                                        } = submenuItemValues[subItem.NAME] || {};
                                        return (
                                            <li key={subIndex} className="flex  items-center  gap-1  py-1">
                                                <button
                                                    type="button"
                                                    className=""
                                                    onClick={(event) => {
                                                        const result = handleAddItemClick(event, subItem);
                                                        setSubmenuItemValues((prevState) => ({
                                                            ...prevState,
                                                            [subItem.NAME]: {
                                                                nextValue: result.value,
                                                                nextPoints: result.points
                                                            },
                                                        }));
                                                    }}
                                                >
                                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                                         fill="currentColor" className="w-6 h-6">
                                                        <path
                                                            d="M10.75 4.75a.75.75 0 00-1.5 0v4.5h-4.5a.75.75 0 000 1.5h4.5v4.5a.75.75 0 001.5 0v-4.5h4.5a.75.75 0 000-1.5h-4.5v-4.5z"/>
                                                    </svg>

                                                </button>
                                                <button
                                                    className="remove-button"
                                                    onClick={(event) => {
                                                        const result = handleRemoveItemClick(event, subItem);
                                                        setSubmenuItemValues((prevState) => ({
                                                            ...prevState,
                                                            [subItem.NAME]: {
                                                                nextValue: result.value,
                                                                nextPoints: result.points
                                                            },
                                                        }));
                                                    }}
                                                >
                                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                                         fill="currentColor" className="w-6 h-6">
                                                        <path fillRule="evenodd"
                                                              d="M4 10a.75.75 0 01.75-.75h10.5a.75.75 0 010 1.5H4.75A.75.75 0 014 10z"
                                                              clipRule="evenodd"/>
                                                    </svg>

                                                </button>
                                                <span onClick={() => handleDataItemClick(subItem, menu)}
                                                      className="flex  flex-auto  justify-between  text-xs">
                                                            <span className="capitalize">{subItem.NAME.toLowerCase()}</span>
                                                            <span>{itemCount > 0 && `(${nextValue}) - ${nextPoints}pts`}</span>
                                                        </span>
                                            </li>


                                        );
                                    })}


                            </ul>

                        )}
                    </li>

                ))}
            </ul>
        </div>
    </div>;
}

export default UnitMenu;
